import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_CHECK_KYC_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_CHECK_KYC_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_CHECK_KYC_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/users/${id}/check-kyc`,
    method: 'GET',
  })
);

export default apiCall;
